'use client'

import { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

interface ReCaptchaProviderProps {
	children: ReactNode
}

export function ReCaptchaProvider({ children }: ReCaptchaProviderProps) {
	const reCaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

	if (!reCaptchaKey) {
		return <>{children}</>
	}

	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={reCaptchaKey}
			scriptProps={{
				async: true,
				defer: true,
				appendTo: 'head'
			}}
		>
			{children}
		</GoogleReCaptchaProvider>
	)
}
